import type { IUseQueryCampaignsByTypeReturn } from '~/modules/campaign-template/hooks/useQueryCampaignsByType';
import type { CampaignTemplatesQueryVariables } from '~/api/graphql/queries/campaignTemplates.generated';

import { useQueryCampaignsByType } from '~/modules/campaign-template/hooks/useQueryCampaignsByType';
import { CAMPAIGN_TYPE, CAMPAIGNS_QUERY_PAGE_SIZE } from '~/constants/campaign';
import { useCampaignStore } from '~/modules/campaign';

export const campaignUrlsQueryVariables: CampaignTemplatesQueryVariables = {
  first: CAMPAIGNS_QUERY_PAGE_SIZE,
  where: {
    type: CAMPAIGN_TYPE.URL,
    hasVariants: true,
    deletedAtIsNil: true,
  },
};

export const useQueryCampaignUrls = (): IUseQueryCampaignsByTypeReturn => {
  const isQueryCampaignUrl = useCampaignStore((state) => state.isQueryCampaignUrl);
  const setIsQueryCampaignUrl = useCampaignStore((state) => state.setIsQueryCampaignUrl);

  return useQueryCampaignsByType({
    type: CAMPAIGN_TYPE.URL,
    queryVariables: campaignUrlsQueryVariables,
    isQueried: isQueryCampaignUrl,
    setIsQueried: setIsQueryCampaignUrl,
    getIsQueried: () => useCampaignStore.getState().isQueryCampaignUrl,
    sentrySource: 'useQueryCampaignUrls',
  });
};
